export const LLM_REFERRING_HOSTS = [
    'chatgpt.com',
    'chat.openai.com',
    'openai.com',
    'perplexity.ai',
    'claude.ai',
    'gemini.google.com',
    'copilot.microsoft.com',
    'vertexaisearch.cloud.google.com',
];
const ORGANIC_SEARCH_HOSTS = new Set([
    'bing.com',
    'www.bing.com',
    'duckduckgo.com',
    'www.duckduckgo.com',
    'search.yahoo.com',
]);
const GOOGLE_ADS_HOSTS = new Set([
    'googleadservices.com',
    'www.googleadservices.com',
    'googlesyndication.com',
    'www.googlesyndication.com',
    'ads.google.com',
    'mail.google.com',
    'accounts.google.com',
]);
const SAME_SITE_HOSTS = new Set([
    'oidotipi.com',
    'www.oidotipi.com',
    'app.oidotipi.com',
    'tipi.ink',
    'www.tipi.ink',
    'oktipi.com',
    'www.oktipi.com',
]);
export const normalizeReferringHost = (referrerUrl) => {
    if (referrerUrl == null)
        return undefined;
    const trimmed = referrerUrl.trim();
    if (!trimmed)
        return undefined;
    try {
        const url = trimmed.includes('://') ? new URL(trimmed) : new URL(`https://${trimmed}`);
        const host = url.hostname.trim().toLowerCase();
        return host.length > 0 ? host : undefined;
    }
    catch {
        return undefined;
    }
};
const hasPaidSignal = (input) => Boolean(input.utm_source ||
    input.utm_medium ||
    input.utm_campaign ||
    input.utm_term ||
    input.utm_content ||
    input.fbclid ||
    input.gclid ||
    input.gad_source ||
    input.gad_campaignid ||
    input.gbraid);
const stripWww = (host) => (host.startsWith('www.') ? host.slice(4) : host);
const isSameSiteHost = (host) => SAME_SITE_HOSTS.has(host) || SAME_SITE_HOSTS.has(stripWww(host));
const isLlmHost = (host) => {
    const normalized = stripWww(host);
    return LLM_REFERRING_HOSTS.includes(normalized);
};
const isOrganicSearchHost = (host) => {
    if (GOOGLE_ADS_HOSTS.has(host) || GOOGLE_ADS_HOSTS.has(stripWww(host)))
        return false;
    if (ORGANIC_SEARCH_HOSTS.has(host) || ORGANIC_SEARCH_HOSTS.has(stripWww(host)))
        return true;
    const withoutWww = stripWww(host);
    if (withoutWww === 'google.com' || withoutWww.startsWith('google.'))
        return true;
    if (withoutWww === 'bing.com' || withoutWww === 'duckduckgo.com')
        return true;
    return false;
};
export const deriveAcquisitionChannel = (input) => {
    if (hasPaidSignal(input))
        return 'paid_utm';
    const host = input.referring_domain?.trim().toLowerCase();
    if (!host || isSameSiteHost(host))
        return 'direct';
    if (isLlmHost(host))
        return 'llm';
    if (isOrganicSearchHost(host))
        return 'organic_search';
    return 'referral';
};
//# sourceMappingURL=AcquisitionChannel.js.map